import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "auth-main-wrapper col-lg-5 col-md-6 col-sm-12 mt-5" }
const _hoisted_2 = { class: "auth-inner-div w-100 text-center" }
const _hoisted_3 = { class: "auth-header" }
const _hoisted_4 = { class: "auth-inner-form-div" }
const _hoisted_5 = { class: "auth-input-wrapper w-100" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "error-color font-small"
}
const _hoisted_8 = {
  key: 1,
  class: "error-color font-small"
}
const _hoisted_9 = {
  key: 2,
  class: "error-color font-small"
}
const _hoisted_10 = { class: "auth-inner-div w-100" }
const _hoisted_11 = { class: "auth-inner-div w-100" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "w-100" }
const _hoisted_14 = {
  key: 0,
  class: "error-color font-small"
}
const _hoisted_15 = {
  key: 1,
  class: "auth-inner-div w-100"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 2,
  class: "auth-inner-div w-100"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "auth-inner-div auth-bottom-sentence w-100 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputComponent = _resolveComponent("InputComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('customer_self_service')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isLogin)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              (_ctx.responseStatus === 401)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('invalid_user')), 1))
                : _createCommentVNode("", true),
              (_ctx.responseStatus === 403)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('account_not_verified')), 1))
                : _createCommentVNode("", true),
              (_ctx.responseStatus === 422)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('invalid_inputs')), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.inputs, (input) => {
          return (_openBlock(), _createBlock(_component_InputComponent, {
            class: "w-100 auth-input mx-auto",
            "name-input": input.name,
            "data-type": input.dataType,
            placeholder: _ctx.$t(input.placeholder),
            data: input.value,
            "onUpdate:data": ($event: any) => ((input.value) = $event),
            msg: input.validation
          }, null, 8, ["name-input", "data-type", "placeholder", "data", "onUpdate:data", "msg"]))
        }), 256))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_link, {
        class: "blue",
        to: "/forgot-password"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('forgot_password')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "auth-customer-login-button w-100",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"])),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"])),
        disabled: _ctx.loading
      }, _toDisplayString(_ctx.$t('login')), 41, _hoisted_12)
    ]),
    _createElementVNode("div", _hoisted_13, [
      (_ctx.isSocialLogin && _ctx.responseStatus)
        ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.responseStatus === 401 ? _ctx.$t('social_login_error') : '') + " " + _toDisplayString(_ctx.responseStatus === 403 ? _ctx.$t('account_not_verified') : '') + " " + _toDisplayString(_ctx.responseStatus === 422 ? _ctx.$t('declined_login_method') : ''), 1))
        : _createCommentVNode("", true),
      (_ctx.store.state.socialAuth.google_login === '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "auth-soc-buttons w-100",
              disabled: _ctx.loading,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.socialLogin(_ctx.SocialAuthProviders.GOOGLE)))
            }, [
              _cache[4] || (_cache[4] = _createStaticVNode("<span class=\"auth-button-icon\"><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.7875 10.2271C19.7875 9.51801 19.7239 8.83619 19.6057 8.18164H10.1875V12.0498H15.5693C15.3375 13.2998 14.633 14.3589 13.5739 15.068V17.5771H16.8057C18.6966 15.8362 19.7875 13.2726 19.7875 10.2271Z\" fill=\"#4285F4\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.1871 20.0004C12.8871 20.0004 15.1508 19.105 16.8053 17.5777L13.5735 15.0686C12.678 15.6686 11.5326 16.0231 10.1871 16.0231C7.58256 16.0231 5.37801 14.264 4.59165 11.9004H1.25073V14.4913C2.89619 17.7595 6.27802 20.0004 10.1871 20.0004Z\" fill=\"#34A853\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.59205 11.8997C4.39205 11.2997 4.27842 10.6588 4.27842 9.99971C4.27842 9.34062 4.39205 8.6997 4.59205 8.0997V5.50879H1.25114C0.573864 6.85879 0.1875 8.38607 0.1875 9.99971C0.1875 11.6133 0.573864 13.1406 1.25114 14.4906L4.59205 11.8997Z\" fill=\"#FBBC05\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.1871 3.97728C11.6553 3.97728 12.9735 4.48183 14.0099 5.47274L16.878 2.60455C15.1462 0.990911 12.8826 0 10.1871 0C6.27802 0 2.89619 2.24091 1.25073 5.5091L4.59165 8.10002C5.37801 5.73638 7.58256 3.97728 10.1871 3.97728Z\" fill=\"#EA4335\"></path></svg></span>", 1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('google_login')), 1)
            ], 8, _hoisted_16)
          ]))
        : _createCommentVNode("", true),
      (_ctx.store.state.socialAuth.facebook_login === '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "auth-soc-buttons w-100",
              disabled: _ctx.loading,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.socialLogin(_ctx.SocialAuthProviders.FACEBOOK)))
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "auth-button-icon" }, [
                _createElementVNode("svg", {
                  width: "12",
                  height: "23",
                  viewBox: "0 0 12 23",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M7.65708 12.3648H11.3793L11.9637 8.56055H7.65632V6.48134C7.65632 4.90099 8.16957 3.49962 9.63891 3.49962H12V0.179741C11.5852 0.123382 10.7078 0 9.04996 0C5.58819 0 3.55867 1.8393 3.55867 6.0297V8.56055H0V12.3648H3.55867V22.821C4.26344 22.9276 4.97729 23 5.71007 23C6.37245 23 7.01893 22.9391 7.65708 22.8522V12.3648Z",
                    fill: "#0029FF"
                  })
                ])
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('facebook_login')), 1)
            ], 8, _hoisted_18)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createTextVNode(_toDisplayString(_ctx.$t('dont_have_account') + ' ') + " ", 1),
      _createVNode(_component_router_link, {
        class: "blue",
        to: "/register"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('register')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}